import { render, staticRenderFns } from "./TheExpiringInDays.vue?vue&type=template&id=2e39a457&scoped=true"
import script from "./TheExpiringInDays.vue?vue&type=script&lang=ts"
export * from "./TheExpiringInDays.vue?vue&type=script&lang=ts"
import style0 from "./TheExpiringInDays.vue?vue&type=style&index=0&id=2e39a457&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e39a457",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoreSelectTheDateModal: require('/usr/src/nuxt-app/components/core/select/TheDateModal.vue').default})
